module.exports = __webpack_public_path__ + "img/across back.30b23966.png";